import React, {createContext, FC, ReactNode, useContext, useEffect, useState} from 'react';
import {Referral} from '@raf/core/domain/Referral';
import {getReferral} from '@views/Referrals/Referrals.controller';

const DEFAULT_REFERRAL: Referral = {
  numberOfReferredApplied: 0,
  numberOfReferredRegistered: 0,
  referreds: [],
  referralCredit: 0,
  referredCredit: 0,
  referralCode: '',
  enabled: true,
  totalBalance: 0,
};

const ReferralsContext = createContext<ReferralContextValue>({
  hasReferreds: false,
  loading: false,
  referralInfo: DEFAULT_REFERRAL,
});

export interface ReferralContextValue {
  hasReferreds: boolean;
  referralInfo: Referral;
  loading: boolean;
}

export const ReferralsProvider: FC<{children: ReactNode}> = ({children}) => {
  const [referral, setReferral] = useState<Referral>(DEFAULT_REFERRAL);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getReferral()
      .then(rafInfo => {
        if (rafInfo) setReferral(rafInfo);
      })
      .finally(() => setLoading(false));
  }, []);

  const value: ReferralContextValue = {
    hasReferreds: referral && referral.referreds && referral.referreds.length > 0,
    referralInfo: referral,
    loading,
  };

  return <ReferralsContext.Provider value={value}>{children}</ReferralsContext.Provider>;
};

export const useReferrals = (): ReferralContextValue => {
  const context = useContext(ReferralsContext);

  if (context === undefined) throw new Error('useReferrals must be used within a ReferralsContext');

  return context;
};
